import { StationsState } from '../../types';

export const resetFilteredStations = (
  state: StationsState
) => {
  state.filteredStations.data = [];
};
